











































































import { Component, Vue, Prop ,Watch } from "vue-property-decorator";


@Component({})
export default class pluginDialog extends Vue {
  @Prop()
  plugInDialogShow!: boolean;

  @Prop()
  handleClose!: Function;

  @Prop()
  inPop!: boolean;

  @Prop()
  close!: Function;

  @Prop()
  isShopify!: boolean;

  @Prop({ type: String, default: '' })
  gateMode!: string;

  @Prop({ type: String, default: '' })
  authorizationUrl!: string;

  @Prop({ type: String, default: '' })
  recheckMessage!: string;

  @Prop({ type: String, default: '' })
  formId!: string;

  @Prop({ type: Function, default: null })
  forceContinue!: (() => void) | null;

  recheckLoading = false;

  get isShopifyGate() {
    return this.gateMode === 'enable' || this.gateMode === 'authorize' || this.gateMode === 'reauth' || this.gateMode === 'retry';
  }

  get shortGate() {
    return this.gateMode === 'reauth' || this.gateMode === 'retry';
  }

  get dialogClass() {
    if (this.shortGate) {
      return '';
    }
    if (this.isShopifyGate) {
      return 'plugin-dialog plugin-dialog-gate';
    }
    return 'plugin-dialog';
  }

  get dialogWidth() {
    if (this.shortGate) {
      return '480px';
    }
    if (this.isShopifyGate) {
      return '600px';
    }
    return '762px';
  }

  get dialogTitle() {
    if (this.gateMode === 'reauth') {
      return this.$tx('form.install.gateTitleReauth', '店铺授权已失效，请重新授权');
    }
    if (this.gateMode === 'retry') {
      return this.$tx('form.install.gateTitleRetry', '暂时无法确认主题嵌入状态');
    }
    if (this.gateMode === 'authorize') {
      return this.$tx('form.install.gateTitleAuth', '发布前需开启主题嵌入并完成授权');
    }
    if (this.isShopifyGate) {
      return this.$tx('form.install.gateTitle', '发布前需开启主题嵌入');
    }
    return this.$tx('form.install.title', '安装订阅工具');
  }

  public continuePublish() {
    if (this.recheckLoading) {
      return;
    }
    if (this.forceContinue) {
      this.forceContinue();
    }
  }

  public async runRecheck() {
    if (this.recheckLoading) {
      return;
    }
    this.recheckLoading = true;
    try {
      await Promise.resolve(this.handleClose());
    } finally {
      this.recheckLoading = false;
    }
  }

  public openAuthorization() {
    if (!this.authorizationUrl) {
      this.$message.error(this.$tx('form.install.authUrlMissing', '暂时无法获取 Shopify 授权地址，请稍后重试'));
      return;
    }
    const reauth = this.gateMode === 'reauth';
    this.trackGateClick(
      reauth ? 'form_install_reauthorize' : 'form_install_goAuthorize',
      reauth ? '弹窗_发布拦截_重新授权' : '弹窗_发布拦截_前往授权'
    );
    window.open(this.authorizationUrl);
  }

  public openInstall() {
    this.trackGateClick('form_install_goEnable', '弹窗_发布拦截_前往开启');
    this.jumpToInstallUrl();
  }

  public trackGateClick(eventKey: string, eventName: string) {
    const companyInfo = JSON.parse(localStorage.getItem('companyInfo') || '{}');
    const displayInfo = JSON.parse(localStorage.getItem('displayInfo') || '{}');
    const popId = this.formId || '';
    window?.gtagNew?.('event', eventKey, {
      event_name: eventName,
      event_type: '按钮点击',
      Company_id: companyInfo?.id,
      login_id: displayInfo?.id,
      login_type: displayInfo?.innerUserType,
      path_url: window.location.href,
      popId,
      gate_mode: this.gateMode,
      time: new Date()
    });
  }

  public getInstallJumpUrl() {
    const companyInfo = JSON.parse(localStorage.getItem('companyInfo') || '{}');
    if (companyInfo.shop) {
      if (companyInfo.shop.includes('shopify')) {
        return `https://${companyInfo.shop}/admin/themes/current/editor?context=apps&activateAppId=3cb8722a-4436-4e4c-88af-b33e3fe7857a/onsite-javascript`;
      } else if (companyInfo.shop.includes('shopline')) {
        return `https://${companyInfo.shop}/admin/theme/editor/editing/Home?templateName=templates%2Findex.json&activateAppId=5d87df78-5746-4440-b2ec-0336110c2dc6%2Fonsite-javascript`;
      }
    }
    if (this.isShopify) {
      return `https://${companyInfo.shopPre}.myshopify.com/admin/themes/current/editor?context=apps&activateAppId=3cb8722a-4436-4e4c-88af-b33e3fe7857a/onsite-javascript`;
    } else {
      return `https://${companyInfo.shopPre}.myshopline.com/admin/theme/editor/editing/Home?templateName=templates%2Findex.json&activateAppId=5d87df78-5746-4440-b2ec-0336110c2dc6%2Fonsite-javascript`;
    }
    return ``;
  }
  get installHint2() {
    const platform = this.getType() == 'shopify' ? 'Shopify' : 'Shopline';
    return this.$tx('form.install.hint2', '您需要在 {{platform}} 中启用您的应用嵌入：', { platform });
  }
  public getType() {
    const companyInfo = JSON.parse(localStorage.getItem('companyInfo') || '{}');
    if (companyInfo.shop) {
      if (companyInfo.shop.includes('shopify')) {
        return `shopify`;
      } else if (companyInfo.shop.includes('shopline')) {
        return `shopline`;
      }
    }
    if (this.isShopify) {
      return `shopify`;
    } else {
      return `shopline`;
    }
    return ``;

  }
  public jumpToInstallUrl() {
    window.open(this.getInstallJumpUrl());
  }
}
